import { TEAL_3CE } from "@frontend/palette";
import { Link as InertiaLink, usePage } from "@inertiajs/react";
import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Link as MuiLink,
} from "@mui/material";
import React from "react";

export interface SidebarItemType {
  label: string;
  id: string;
  icon?: React.ComponentType;
  href?: string;
  urlPattern?: RegExp;
  onClick?: () => void;
  ariaExpanded?: boolean;
}

export default function SidebarItem({
  isSidebarOpen,
  item,
}: {
  isSidebarOpen: boolean;
  item: SidebarItemType;
}) {
  const { url } = usePage();

  const Icon = item.icon;
  const isActive =
    !item.onClick &&
    (item.urlPattern ? item.urlPattern.test(url) : url === item.href);

  const linkProps = item.onClick
    ? { onClick: item.onClick }
    : {
        href: item.href,
        LinkComponent: item.href?.includes("bellarates")
          ? MuiLink
          : InertiaLink,
      };

  return (
    <ListItem key={item.id} disablePadding>
      <ListItemButton
        {...linkProps}
        aria-label={item.label}
        aria-current={isActive ? "page" : undefined}
        aria-expanded={item.ariaExpanded}
        sx={{
          borderRadius: 1,
          mb: 0.5,
          bgcolor: isActive ? TEAL_3CE : "transparent",
          "&:hover": {
            bgcolor: isActive ? "blue.600" : "grey.200",
          },
          "&:focus-visible": {
            outline: `2px solid ${TEAL_3CE}`,
            outlineOffset: 2,
          },
        }}
      >
        {Icon && (
          <ListItemIcon
            sx={{
              minWidth: 40,
              color: isActive ? "common.white" : "inherit",
            }}
          >
            <Icon />
          </ListItemIcon>
        )}
        {isSidebarOpen && (
          <ListItemText
            primary={item.label}
            sx={{
              my: 0,
              color: isActive ? "common.white" : "inherit",
            }}
            slotProps={{
              primary: {
                fontWeight: 600,
              },
            }}
          />
        )}
      </ListItemButton>
    </ListItem>
  );
}
